export default __webpack_public_path__ + "static/media/virtual-event.0e0cd3b4.png";